import React, { useContext, useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Grid } from "@material-ui/core";
import { ColProps_3 } from "@core/utils/ColProps";
import Typography from "@components/Typography";
import clsx from "clsx";
import { MarketContext } from "@context/MarketContext";
import OrderBookItem from "./OrderBookItem";

const titles = [__t("Price"), __t("size"), __t("Total Amount")];

const TransactionsListComponent = (props) => {
  const {
    items,
    is_fetch,
    type,
    currencyName,
    reverse,
    orderBookLayout,
  } = props;
  const classes = useStyles(props);
  const market = useContext(MarketContext);
  const [hoverIndex, setHoverIndex] = useState(0);
  const [activeCal, setActiveCal] = useState(false);
  const handleHover = (e) => {
    setHoverIndex(e.currentTarget.id);
    setActiveCal(true);
  };

  const handleRemoveHover = (e) => {
    setActiveCal(false);
    setHoverIndex(0);
  };

  const handleClick = () => {
    market.setOrderBookClick(true);
    getAverege(hoverIndex);
  };

  const getAverege = (hoverIndex) => {
    let sumSize = 0,
      sumTotal = 0;
    for (let i = 0; i < hoverIndex; i++) {
      sumSize += items[i].size;
      sumTotal += items[i].unitPrice * items[i].size;
    }
    market.setSelectPriceState((prevState) => ({
      ...prevState,
      unitPrice: items[hoverIndex - 1]?.unitPrice?.toFixed(0),
      size: sumSize?.toFixed(4),
      total: sumTotal?.toFixed(0),
    }));

    market.setOrderType(type === "buy" ? "sell" : "buy");
  };

  const getPercent = (index) => {
    let sum = 0;
    let sumIndex = 0;

    for (let i = 0; i < index + 1; i++) {
      sum += items[i]?.size || 0;
    }
    for (let i = 0; i < items?.length; i++) {
      sumIndex += items[i]?.size || 0;
    }
    if (!sumIndex) return 0;
    return (sum / sumIndex) * 100;
  };

  return (
    <Grid
      item
      container
      direction="column"
      className={classes.container}
      spacing={2}
    >
      <Grid item container direction="row">
        {titles.map((title) => (
          <Grid item {...ColProps_3} container justify="center">
            <Typography variant="3xs" color="secondary.tint100">
              {title}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Grid
        item
        container
        direction={reverse ? "column-reverse" : "column"}
        className={classes.orderBookContainer}
      >
        {is_fetch &&
          items?.map((item, index) => (
            <div
              className={clsx(
                classes.listItemPrices,
                index < hoverIndex &&
                  clsx(
                    reverse
                      ? index !== 0 && classes.hoverItemsClass
                      : index !== hoverIndex - 1 && classes.hoverItemsClass
                  )
              )}
            >
              <OrderBookItem
                item={item}
                items={items}
                index={index}
                handleRemoveHover={handleRemoveHover}
                handleHover={handleHover}
                hoverIndex={hoverIndex}
                handleClick={handleClick}
                reverse={reverse}
                percent={getPercent(index)}
                type={type}
                activeCal={activeCal}
                currencyName={currencyName}
                gradientSide={
                  orderBookLayout === "column" ? "to right" : "to left"
                }
              />
            </div>
          ))}
      </Grid>
    </Grid>
  );
};

export default TransactionsListComponent;
